<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách công việc của CSKH</h1>
      <div class="btn-group float-right">
        <DraggableTable
          :naming="$router.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button
          :disabled="!hasChecked || isLoadingDownloadImage"
          @click="downloadFile"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-download"></i>
          {{ isLoadingDownImage ? 'Đang tải...' : 'Download Ảnh' }}
        </button>
        <button
          v-if="dataPermission && dataPermission?.includes('CNPS_CSS_TASK_MKT_EXPORT')"
          @click="exportExcel"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-download"></i
          >{{ isLoadingDownTemplate ? 'Đang tải...' : 'Download File' }}
        </button>
        <!--  -->
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="filters.merchantName"
              class="form-control f12 hc-37 text-search"
              placeholder="Tên/email merchant"
            />
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12 pt-1"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  TG hoàn thành
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.type"
              :options="Config.getSearch(optionsType)"
              @change="getCatCalendar"
              placeholder="Nhóm công việc"
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.purposes"
              :options="Config.getSearch(optionsPurpose)"
              placeholder="Tên công việc"
              :disabled="!search.type || search.type === '0'"
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2MultipleControl
              :settings="{ placeholder: 'Tên Sale', multiple: false }"
              v-model="filters.saleIds"
              :options="dataManager"
            >
            </Select2MultipleControl>
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.businessRegionCode"
              :options="dataConfigRegion"
              @change="queryProvince($event)"
              placeholder="Vùng kinh doanh"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.businessProvinceCode"
              :options="dataProvince"
              :disabled="!filters.businessRegionCode || filters.businessRegionCode === '0'"
              placeholder="Tỉnh/Thành phố kinh doanh"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.regionCode"
              :options="dataConfigRegionMC"
              @change="queryMcProvince($event)"
              placeholder="Vùng merchant"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.provinceCode"
              :options="dataProvinceMC"
              placeholder="Tỉnh/Thành phố merchant"
              :disabled="!filters.regionCode || filters.regionCode === '0'"
              @change="getMcDistrict($event)"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.districtCode"
              :options="dataDistrict"
              placeholder="Quận/Huyện merchant"
              :disabled="!filters.provinceCode || filters.provinceCode === '0'"
            />
          </div>

          <div class="form-group">
            <Select2
              v-model="filters.handlerMainRegionId"
              :options="dataConfigRegionMC"
              @change="queryMcProvince($event, 1)"
              placeholder="Vùng của người xử lý"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.handlerMainProvinceId"
              :options="dataProvinceMC2"
              placeholder="Tỉnh của người xử lý"
              :disabled="!filters.handlerMainRegionId || filters.handlerMainRegionId === '0'"
            />
          </div>
          <!-- @change
          ="getMcDistrict($event)" -->
          <div class="form-group">
            <!-- <Select2
              v-model="filters.status"
              :options="statusOptions"
              placeholder="Trạng thái"
            /> -->
            <Select2
              v-model="filters.statuses"
              :options="statusOptions"
              placeholder="Trạng thái"
              :settings="{
                multiple: true,
                containerCssClass: 'select2-container--nowrap',
                selectionCssClass: 'select2-selection--nowrap',
              }"
              class="custom-select2"
            />
          </div>
          <div class="form-group form-group-action">
            <button
              class="btn btn-primary hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
              @click="submitForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              type="button"
              class="btn btn-outline-light hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
              @click="removeForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng: <strong class="text-primary">{{ pagination.total }}</strong>
            <b-table
              :busy.sync="tbLoading"
              sticky-header
              responsive
              hover
              :items="lists"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #head(checkbox)>
                <b-form-checkbox
                  v-model="selectAll"
                  @change="toggleSelectAll"
                  :disabled="loading"
                />
              </template>
              <template #cell(checkbox)="{ item }">
                <b-form-checkbox v-model="item.checked" @change="toggleSelectOne(item)" />
              </template>
              <template #cell(merchantName)="{ item }">
                <p>{{ item.customerInfoRes?.merchantName }}</p>
              </template>
              <template #cell(operationType)="{ item }">
                <b-badge :variant="getStatusBadge(item.approvedStatus)">
                  {{ getStatusName(item.approvedStatus) }}
                </b-badge>
                <div v-if="item.reasonReject && item.approvedStatus === 'REJECTED'" class="mt-2">
                  Lý do: {{ item.reasonReject }}
                </div>
              </template>
              <template #cell(saleName)="{ item }">
                <p>{{ item.assignee?.name }}</p>
              </template>
              <template #cell(approveInfo)="{ item }">
                <p>{{ item.approvedName }}</p>
              </template>
              <template #cell(mainBusinessMcc)="{ item }">
                <p>
                  {{ getBusinessTypeName(item.customerInfoRes.mainBusinessMcc) }}
                </p>
              </template>
              <template #cell(typePurposes)="{ item }">
                <p v-if="item.type">
                  <span class="text-muted">Nhóm:</span>
                  {{ joinArrayData(item.type, optionsType) }}
                </p>
                <p v-if="item.name">
                  <span class="text-muted">Tên công việc:</span>
                  <span>
                    {{ item.name }}
                  </span>
                </p>
              </template>
              <template #cell(createdTime)="{ item }">
                <p>
                  <b>Tạo:</b>
                  {{ item.createdDate | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
                <p v-if="item.endProcessingTime">
                  <b>Hoàn thành:</b>
                  {{ item.endProcessingTime | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
                <p v-if="item.approvedDate">
                  <b>Duyệt:</b>
                  {{ item.approvedDate | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </template>
              <template #cell(action)="{ item }">
                <b-dropdown class="text-center" variant="outline-light">
                  <b-dropdown-item @click="detail(item.id)" class="dropdown-item"
                    ><span>&nbsp;</span>Chi tiết
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <div class="d-flex align-items-center justify-content-end">
            <b-form-group class="mb-0 mr-3">
              <b-form-select
                v-model="search.limit"
                :options="pageOptions"
                @change="onItemsPerPageChange"
              ></b-form-select>
            </b-form-group>
            <b-pagination
              v-model="search.page"
              :total-rows="pagination.total"
              :per-page="search.limit"
              class="fl-right mr-2"
              @change="handlePageChange"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="modal-noti" centered v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          @click="close()"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" />
        <h2 class="f18 py-3">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>
    <ModalExportNoti ref="uploadNotif" />

    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { StaffService } from '@/services/staff.service'
  import { mapGetters } from 'vuex'
  import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
  import 'vue-simple-suggest/dist/styles.css'
  import Config from '@/thirdParty/config'
  import moment from 'moment'
  import ModalExportNoti from '@/components/ModalExportNoti.vue'

  import {
    // DownloadFile,
    // DownloadTemplate,
    StickerStandeeService,
    DownloadImage,
    GetListImages,
  } from '@/services/sticker-standee.service'
  import cloneDeep from 'lodash/cloneDeep'
  import { CommonService } from '@/services/common.service'
  import { WorkGroupList, WorkTaskList } from '@/services/customer-support/task'
  import { saveAs } from 'file-saver'
  import JSZip from 'jszip'
  import { level3LocationDetails } from '@/config/manhthdConfigs'
  import { getFileExtension } from '@/utils/util'

  const fieldsTable = [
    {
      key: 'checkbox',
      label: '',
      sortable: false,
      thStyle: 'width: 30px; text-align: center',
    },
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'merchantName', label: 'MC' },
    { key: 'saleName', label: 'Tên Sale' },
    { key: 'approveInfo', label: 'Người duyệt' },
    { key: 'createdTime', label: 'Thời gian' },
    { key: 'customerInfoRes.provinceName', label: 'Tỉnh/Thành' },
    { key: 'mainBusinessMcc', label: 'Ngành nghề' },
    { key: 'typePurposes', label: 'Nhóm/Tên công việc' },
    { key: 'operationType', label: 'Trạng thái' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  const maxtSelect = 200

  export default {
    name: 'sticker-standee-cskh',
    mixins: [prepareQueryParamsMixin],
    components: { ModalExportNoti },

    data() {
      return {
        Config,
        fieldsTable,
        filterTable: fieldsTable,
        lists: [],
        dataConfigMcc: [],
        optionsType: [],
        optionsPurpose: [],
        wkTaskResList: [],
        loading: false,
        tbLoading: false,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        dataManager: [],
        filters: {
          merchantName: '',
          saleIds: '',
          // status: '',
          statuses: [],
          fromTimeComplete: '',
          toTimeComplete: '',
          handlerMainRegionId: '',
          handlerMainProvinceId: '',
        },
        isLoadingDownImage: false,
        isLoadingDownTemplate: false,
        dataConfigRegion: [],
        dataConfigRegionMC: [],
        dataProvince: [],
        dataProvinceMC: [],
        dataProvinceMC2: [],
        dataDistrict: [],

        search: {
          limit: 20,
          page: 1,
          type: '',
          purposes: '',
        },
        pagination: {
          total: 0,
        },
        dateRange: {
          startDate: null,
          endDate: null,
        },
        notiModal: false,
        msgNoti: '',
        iconNoti: '',
        selectAll: false,
        idsSelected: [],
        maxtSelect,
        // Mốc trang,
        pageOptions: [
          { value: 20, text: '20/trang' },
          { value: 50, text: '50/trang' },
          { value: 100, text: '100/trang' },
          { value: 200, text: '200/trang' },
        ],
        isLoadingDownloadImage: false,
      }
    },
    async created() {
      if (this.dataPermission.includes('CNPS_CSS_TASK_MKT_LIST')) {
        await Promise.allSettled([
          this.configSystem(),
          this.fetchSuperiors(),
          this.getOptionType(),
          this.fetchData(),
        ]).catch(e => console.log(e))
        await this.getRegions()
        await this.getMcRegions()
      } else {
        this.$bvModal
          .msgBoxOk('Bạn không có quyền truy cập vào trang này', {
            title: 'Cảnh báo',
            okVariant: 'danger',
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true,
          })
          .then(() => {
            this.$router.replace('/')
          })
      }
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          limit: this.search.limit,
          page: this.search.page,
        })
      },
      joinArrayData() {
        return (item, options) => {
          const mapData = options.find(e => e.id === item)
          return mapData ? mapData.text : ''
        }
      },
      hasChecked() {
        return this.idsSelected.length > 0
      },
      // statusOptions() {
      //   return [{ id: '0', text: 'Tất cả' }, ...Config.statusCskhJob]
      // },
      statusOptions() {
        return [...Config.statusCskhJob]
      },
      getStatusName() {
        return id => {
          const status = Config.statusCskhJob.find(status => status.id === id)
          return status ? status.text : 'Chưa duyệt'
        }
      },
      getStatusBadge() {
        return id => {
          const status = Config.statusCskhJob.find(status => status.id === id)
          return status ? status.badge : 'warning'
        }
      },
      getBusinessTypeName() {
        return mcc => {
          const objStatus = this.dataConfigMcc.find(s => s.code === mcc)
          return objStatus ? objStatus.name : mcc
        }
      },
    },
    methods: {
      prepareData() {
        const conditions = []
        if (this.filters.merchantName) {
          conditions.push(
            `({customerInfoRes.merchantName} LIKE '''${this.filters.merchantName}''' OR {customerInfoRes.email} LIKE '''${this.filters.merchantName}''')`
          )
        }
        if (this.filters.regionCode && this.filters.regionCode !== '0') {
          const newCode =
            this.dataConfigRegionMC.find(item => item.id == this.filters.regionCode) || ''
          conditions.push(`{locationData.regionCodeTask} == '''${newCode?.code}'''`)
        }
        if (this.filters.provinceCode && this.filters.provinceCode !== '0') {
          conditions.push(`{locationData.provinceCodeTask} == '''${this.filters.provinceCode}'''`)
        }
        if (this.filters.districtCode && this.filters.districtCode !== '0') {
          conditions.push(`{locationData.districtCodeTask} == '''${this.filters.districtCode}'''`)
        }

        if (this.dateRange.startDate && this.dateRange.endDate) {
          conditions.push(
            `{endProcessingTime} range [#${moment(this.dateRange.startDate).startOf('day').add(7, 'hours').toISOString()}#, #${moment(this.dateRange.endDate).endOf('day').add(7, 'hours').toISOString()}#]`
          )
        }
        if (this.filters.saleIds && this.filters.saleIds !== '0') {
          conditions.push(`{assignee.userId} == '''${this.filters.saleIds}'''`)
        }
        // if (this.filters.status && this.filters.status !== '0') {
        //   conditions.push(`{approvedStatus} == '''${this.filters.status}'''`)
        // }
        if (this.filters.statuses.length > 0) {
          conditions.push(`{approvedStatus} IN ['''${this.filters.statuses.join("''', '''")}''']`)
        }

        if (this.search.type) {
          this.search.type !== '0' && conditions.push(`{type} == '''${this.search.type}'''`)
        }
        if (this.search.purposes) {
          this.search.purposes !== '0' &&
            conditions.push(`{purposes} INCLUDE '''${this.search.purposes}'''`)
        }

        this.search.queryString = conditions.join(' AND ')

        this.filters.businessRegionCode &&
          this.filters.businessRegionCode !== '0' &&
          (this.search.businessRegionCode = this.filters.businessRegionCode)
        this.filters.businessProvinceCode &&
          this.filters.businessProvinceCode !== '0' &&
          (this.search.businessProvinceCode = this.filters.businessProvinceCode)

        this.filters.handlerMainRegionId &&
          this.filters.handlerMainRegionId !== '0' &&
          (this.search.handlerMainRegionId = this.filters.handlerMainRegionId)

        this.filters.handlerMainProvinceId &&
          this.filters.handlerMainProvinceId !== '0' &&
          (this.search.handlerMainProvinceId = this.dataProvinceMC2.find(
            item => item.id === this.filters.handlerMainProvinceId
          ).newId)

        const params = cloneDeep(this.search)
        return params
      },
      async exportExcel() {
        this.isLoadingDownTemplate = true
        try {
          const params = this.prepareData()
          delete params.pageIndex
          delete params.pageSize
          const body = {
            object: {
              ...params,
              ...(this.idsSelected.length > 0 && { ids: this.idsSelected.slice(0, 500) || [] }),
            },
            type: 'CNPS_CSS_TASK_MKT',
          }
          const data = await CommonService.receiveFile(body)
          if (data.success) {
            this.openModalLoadFile(data.data.id)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.isLoadingDownTemplate = false
        }
      },
      openModalLoadFile(id) {
        this.$refs.uploadNotif.triggerNotification(id)
      },

      configSystem() {
        return CommonService.getConfigSystem()
          .then(data => {
            if (data.success) {
              this.dataConfigMcc = data.data.businessFields
            }
          })
          .catch(error => console.error(error))
      },

      // lấy vùng
      async getRegions() {
        const data = await StaffService.getRegions()
        if (data.data.length > 0) {
          this.dataConfigRegion = data.data.map(e => {
            return {
              id: e.id,
              text: e.name,
            }
          })
          this.dataConfigRegion.unshift({ id: '0', text: 'Tất cả' })
        }
      },
      // lấy tỉnh, tp
      async queryProvince(e) {
        try {
          this.businessProvinceCode = ''
          this.dataProvince = []
          const data = await StaffService.getProvinceRegion({ regionId: [e] })
          if (data.data.length > 0) {
            this.dataProvince = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
            this.dataProvince.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (error) {}
      },
      // lấy vùng mc
      async getMcRegions() {
        const data = await StaffService.getListRegions()
        if (data.data.length > 0) {
          this.dataConfigRegionMC = data.data.map(e => {
            return {
              id: e.id,
              text: e.name,
              code: e.code,
            }
          })
          this.dataConfigRegionMC.unshift({ id: '0', text: 'Tất cả' })
        }
      },
      // lấy tỉnh, tp mc
      async queryMcProvince(e, type = 0) {
        if (type === 0) {
          try {
            this.filters.provinceCode = ''
            this.filters.districtCode = ''
            this.dataDistrict = []
            this.dataProvinceMC = []
            const data = await StaffService.getProvinceRegion({ regionId: [e] })
            if (data.data.length > 0) {
              this.dataProvinceMC = data.data.map(e => {
                return {
                  id: e.code,
                  text: e.name,
                  newId: e.id,
                }
              })
              this.dataProvinceMC.unshift({ id: '0', text: 'Tất cả' })
            }
          } catch (error) {}
        } else {
          try {
            this.filters.handlerMainProvinceId = ''
            this.dataProvinceMC2 = []
            const data = await StaffService.getProvinceRegion({ regionId: [e] })
            if (data.data.length > 0) {
              this.dataProvinceMC2 = data.data.map(e => {
                return {
                  id: e.code,
                  text: e.name,
                  newId: e.id,
                }
              })
              this.dataProvinceMC2.unshift({ id: '0', text: 'Tất cả' })
            }
          } catch (error) {}
        }
      },
      // lấy quận mc
      async getMcDistrict(event) {
        this.dataDistrict = level3LocationDetails
          .filter(item => item.code.includes(event))
          .sort((a, b) => a.code.localeCompare(b.code))
          .map(e => {
            return {
              id: e.code,
              text: e.name,
            }
          })
        this.dataDistrict.unshift({ id: '0', text: 'Tất cả' })
      },

      // mốc trang
      async onItemsPerPageChange() {
        this.search.page = 1
        // this.removeForm()
        await this.fetchData()
      },
      async downloadFile() {
        const ids = this.idsSelected
        this.isLoadingDownImage = true
        try {
          // const res = await DownloadFile({ ids })
          // if (res.code === 4000) {
          //   this.showFailMx(
          //     res.message ? res.message : 'Có lỗi xảy ra khi tải file'
          //   )
          //   return
          // }
          // const now = moment().format('DD-MM-YYYY')
          // saveAs(res, `image-sticker-amex-${now}.zip`)
          this.isLoadingDownloadImage = true
          const res = await GetListImages(ids)
          if (res.code === 1000) {
            const zip = new JSZip()
            for (const group of res.data || []) {
              const folder = zip.folder(group.folderName)
              for (const [index, imageUrl] of group.imageUrls.entries()) {
                if (!imageUrl) continue
                try {
                  const res = await DownloadImage(imageUrl)
                  folder.file(`${index + 1}${getFileExtension(imageUrl)}`, res.data, {
                    base64: true,
                  })
                } catch (error) {
                  console.error(`Error downloading image ${imageUrl}:`, error)
                }
              }
            }

            const zipFile = await zip.generateAsync({ type: 'blob' })
            saveAs(zipFile, 'downloaded_images_cskh.zip')
          } else {
            this.showFailMx(res.message)
          }
        } catch (e) {
          this.showFailMx(e.response?.data?.message || e.response.message || e.message)
        } finally {
          this.isLoadingDownloadImage = false
        }
      },
      // async downloadFileTemplate() {
      //   const ids = this.idsSelected
      //   this.isLoadingDownTemplate = true
      //   try {
      //     const res = await DownloadTemplate({ ids })
      //     if (res) {
      //       const now = moment().format('DD-MM-YYYY')

      //       const href = URL.createObjectURL(res)
      //       // download QR
      //       const link = document.createElement('a')
      //       link.href = href
      //       link.setAttribute('download', `template-cskh-${now}.xlsx`)
      //       document.body.appendChild(link)
      //       link.click()
      //       document.body.removeChild(link)
      //       URL.revokeObjectURL(href)
      //     } else {
      //       this.showFailMx(
      //         res.message ? res.message : 'Có lỗi xảy ra khi tải file'
      //       )
      //     }
      //   } catch (e) {
      //     this.showFailMx(
      //       e.response?.data?.message ? e.response.data.message : e.message
      //     )
      //   } finally {
      //     this.isLoadingDownTemplate = false
      //   }
      // },
      // async exportExcel() {
      //   const ids = this.idsSelected
      //   try {
      //     this.showLoading = true
      //     const params = this.prepareData()
      //     delete params.page
      //     delete params.limit
      //     const body = {
      //       object: ids,
      //       type: 'CNPS_DEVICE_DEVICE'
      //     }
      //     const data = await CommonService.receiveFile(body)
      //     if (data.success) {
      //       this.openModalLoadFile(data.data.id)
      //     }
      //   } catch (error) {
      //     console.log(error)
      //   } finally {
      //     this.showLoading = false
      //   }
      // },
      // openModalLoadFile(id) {
      //   this.$refs.uploadNotif.triggerNotification(id)
      // },
      toggleSelectAll() {
        const value = this.selectAll
        for (const item of this.lists) {
          item.checked = value
          const id = item.id
          const index = this.idsSelected.indexOf(id)
          index >= 0 && this.idsSelected.splice(index, 1)
          if (value) {
            !this.idsSelected.includes(id) && this.idsSelected.push(id)
          }
        }
        this.cleanSelectIfOver()
      },
      cleanSelectIfOver() {
        this.idsSelected.length > maxtSelect &&
          (() => {
            this.idsSelected = this.idsSelected.slice(-maxtSelect)
          })()
      },
      toggleSelectOne(item) {
        const id = item.id
        const index = this.idsSelected.indexOf(id)
        index >= 0 && this.idsSelected.splice(index, 1)
        if (item.checked) {
          !this.idsSelected.includes(id) && this.idsSelected.push(id)
        }
        this.selectAll = this.lists.every(item => item.checked)
        this.cleanSelectIfOver()
      },
      async getOptionType() {
        try {
          const response = await WorkGroupList({
            status: 'APPLYING',
            applyFor: 'CV_CS',
            page: 1,
            size: 1000,
            showTasks: true,
          })
          if (response.code && response.code == 1000) {
            this.optionsType = response.data
              ? response.data.reduce((arr, current) => {
                  if (current.groupCode && current.groupName && current.id) {
                    arr.push({
                      id: current.groupCode,
                      text: current.groupName,
                      mapId: current.id,
                    })
                  }
                  return arr
                }, [])
              : []
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        }
      },
      async getCatCalendar() {
        try {
          this.optionsPurpose = []
          this.search.purposes = ''
          const wkGroupId = this.optionsType.find(item => item.id == this.search.type)
          if (!wkGroupId) return

          const response = await WorkTaskList({
            status: 'APPLYING',
            page: 1,
            size: 1000,
            wkGroupId: wkGroupId ? wkGroupId.mapId : '',
          })
          if (response.code && response.code == 1000) {
            this.optionsPurpose = response.data
              ? response.data.reduce((arr, current) => {
                  if (current.taskCode && current.taskName) {
                    arr.push({ id: current.taskCode, text: current.taskName })
                  }
                  return arr
                }, [])
              : []
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        }
      },
      handlePageChange(page) {
        this.search.page = page
        this.$router.replace({
          query: {
            ...this.useInUrlQueryPropList,
            tab: this.$route.query.tab || 0,
          },
        })
        this.fetchData()
      },
      detail(id) {
        const tab = this.$route.query.tab || '0'
        const routeData = this.$router.resolve({
          path: `/sticker-standee/cskh/${id}?tab=${tab}`,
        })
        window.open(routeData.href, '_blank')
      },
      async fetchSuperiors() {
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: JSON.parse(localStorage.getItem('userData')).userId,
          })
          const dat = data.data.map(e => {
            return { id: e.userId, text: e.name }
          })
          this.dataManager = [{ id: '0', text: 'Tất cả' }, ...dat]
        } catch (e) {
          this.showFailMx(e.response?.data?.message ? e.response.data.message : e.message)
        }
      },
      transformDate() {
        this.filters.fromTimeComplete = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.filters.toTimeComplete = moment(this.dateRange.endDate)
          .endOf('day')
          .add(7, 'hours')
          .valueOf()
      },
      async submitForm(event) {
        event.preventDefault()
        this.search.page = 1
        this.selectAll = false
        this.idsSelected = []
        await this.fetchData()
      },
      async removeForm() {
        this.idsSelected = []
        this.search = {
          limit: 20,
          page: 1,
          queryString: '',
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        this.filters = {
          merchantName: '',
          saleIds: '',
          // status: '',
          statuses: [],
          fromTimeComplete: '',
          toTimeComplete: '',
        }
        this.selected = []
        this.selectAll = false
        await this.fetchData()
      },
      async fetchData() {
        try {
          this.tbLoading = true

          const conditions = []
          if (this.filters.merchantName) {
            conditions.push(
              `({customerInfoRes.merchantName} LIKE '''${this.filters.merchantName}''' OR {customerInfoRes.email} LIKE '''${this.filters.merchantName}''')`
            )
          }
          if (this.filters.regionCode && this.filters.regionCode !== '0') {
            const newCode =
              this.dataConfigRegionMC.find(item => item.id == this.filters.regionCode) || ''
            conditions.push(`{locationData.regionCodeTask} == '''${newCode?.code}'''`)
          }
          if (this.filters.provinceCode && this.filters.provinceCode !== '0') {
            conditions.push(`{locationData.provinceCodeTask} == '''${this.filters.provinceCode}'''`)
          }
          if (this.filters.districtCode && this.filters.districtCode !== '0') {
            conditions.push(`{locationData.districtCodeTask} == '''${this.filters.districtCode}'''`)
          }

          if (this.dateRange.startDate && this.dateRange.endDate) {
            conditions.push(
              `{endProcessingTime} range [#${moment(this.dateRange.startDate).startOf('day').add(7, 'hours').toISOString()}#, #${moment(this.dateRange.endDate).endOf('day').add(7, 'hours').toISOString()}#]`
            )
          }
          if (this.filters.saleIds && this.filters.saleIds !== '0') {
            conditions.push(`{assignee.userId} == '''${this.filters.saleIds}'''`)
          }
          // if (this.filters.status && this.filters.status !== '0') {
          //   conditions.push(`{approvedStatus} == '''${this.filters.status}'''`)
          // }
          if (this.filters.statuses.length > 0) {
            conditions.push(`{approvedStatus} IN ['''${this.filters.statuses.join("''', '''")}''']`)
          }

          if (this.search.type) {
            this.search.type !== '0' && conditions.push(`{type} == '''${this.search.type}'''`)
          }
          if (this.search.purposes) {
            this.search.purposes !== '0' &&
              conditions.push(`{purposes} INCLUDE '''${this.search.purposes}'''`)
          }

          this.search.queryString = conditions.join(' AND ')

          this.filters.businessRegionCode &&
            this.filters.businessRegionCode !== '0' &&
            (this.search.businessRegionCode = this.filters.businessRegionCode)
          this.filters.businessProvinceCode &&
            this.filters.businessProvinceCode !== '0' &&
            (this.search.businessProvinceCode = this.filters.businessProvinceCode)

          this.filters.handlerMainRegionId &&
            this.filters.handlerMainRegionId !== '0' &&
            (this.search.handlerMainRegionId = this.filters.handlerMainRegionId)

          this.filters.handlerMainProvinceId &&
            this.filters.handlerMainProvinceId !== '0' &&
            (this.search.handlerMainProvinceId = this.dataProvinceMC2.find(
              item => item.id === this.filters.handlerMainProvinceId
            ).newId)

          const params = cloneDeep(this.search)
          params.pageIndex = params.page
          params.pageSize = params.limit

          const response = await StickerStandeeService.fetchCskh(params)
          if (response.code === 1000) {
            this.lists = response.data.taskList.map(el => {
              return {
                ...el,
                checked: this.idsSelected.includes(el.id),
              }
            })
            this.pagination.total = response.data.total
          } else {
            this.showErr(response.message || 'Có lỗi xảy ra')
          }
          this.selectAll = false
        } catch (e) {
          this.showFailMx(e.response?.data?.message ? e.response.data.message : e.message)
        } finally {
          this.tbLoading = false
        }
      },
      showErr(message) {
        this.notiModal = true
        this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
        this.msgNoti = message
      },
      showSuccess(message) {
        this.notiModal = true
        this.iconNoti = require('@/assets/img/noti-success2.svg')
        this.msgNoti = message
      },
    },
  }
</script>

<style>
  .time-placeholder,
  .text-search::placeholder {
    color: #999 !important;
  }

  .card .card-header .dropdown .dropdown-toggle {
    font-size: 16px !important;
    margin-top: -12px !important;
  }
</style>

<style>
  .select2-container--nowrap .select2-selection--multiple {
    white-space: nowrap !important;
    overflow-x: auto !important;
    height: 38px !important; /* Điều chỉnh chiều cao phù hợp */
  }

  .select2-container--nowrap .select2-selection__rendered {
    white-space: nowrap !important;
    display: inline-block !important;
    padding-bottom: 5px;
  }

  .select2-container--nowrap .select2-selection--multiple .select2-selection__choice {
    float: none !important;
    display: inline-block !important;
    margin-right: 5px !important;
  }
</style>
